import { render } from "./MessageItem.vue?vue&type=template&id=2a9d6874&scoped=true"
import script from "./MessageItem.vue?vue&type=script&lang=js"
export * from "./MessageItem.vue?vue&type=script&lang=js"

import "./MessageItem.vue?vue&type=style&index=0&id=2a9d6874&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9d6874"]])

export default __exports__